'use client'

import TypographyWrapper from '@/components/comman/TypographyWrapper/TypographyWrapper'
import { CarouselProps } from '@/widgets/landing-page-widgets/carousel/schema'
import cn from 'clsx'
import CarouselWrapper from './carousel-wrapper'

export default function CarouselWidget({
  isFullWidth,
  isOuterLayer,
  isHover,
  smallBtns,
  turnOffSideArrows,
  isBtns,
  isLoop,
  isAutoplay,
  items,
  title,
  subTitle,
  addChips,
  isCuriousJr,
  circularArrows,
  homePageVariant,
  largeSideArrows,
  pageData,
}: CarouselProps) {
  if (!items) {
    return <> </>
  }

  return (
    <div className='mt-10 mb-10'>
    <div
      className={cn('flex flex-col', {
        'w-full': isFullWidth,
        container: !isFullWidth,
      })}
    >
      <div
        className={cn('flex flex-col md:gap-2 gap-3 justify-center items-center text-center', {
          'mb-5': isCuriousJr && !addChips,
        })}
      >
        {title && (
          <TypographyWrapper variant='heading2' color='#1B2124' weight='bold'>
            <span className='text-black'>{title}</span>
          </TypographyWrapper>
        )}
        {subTitle && (
          <TypographyWrapper variant='subHeading' color='#3D3D3D' weight='medium'>
            <span className='text-grey-1'>{subTitle}</span>
          </TypographyWrapper>
        )}
      </div>
      <CarouselWrapper
        isFullWidth={isFullWidth}
        isOuterLayer={isOuterLayer}
        isHover={isHover}
        smallBtns={smallBtns}
        turnOffSideArrows={turnOffSideArrows}
        isBtns={isBtns}
        isLoop={isLoop}
        isAutoplay={isAutoplay}
        items={items}
        title={title}
        subTitle={subTitle}
        addChips={addChips}
        isCuriousJr={isCuriousJr}
        circularArrows={circularArrows}
        homePageVariant={homePageVariant}
        largeSideArrows={largeSideArrows}
        pageData={pageData}
      />
    </div>
    </div>
  )
}
